/**
 * Shared discovery copy — the single owner of the "near you" headline and
 * subtitle used by both the homepage browse-first surface and the market page.
 *
 * Market imports the H1 + `formatNearYouSubtitle` only; it does NOT reuse the
 * homepage marketing subline. See buyer-market-discovery-ux § Copy canon (D1, D7).
 */

/** Minimal location shape needed to build the near-you subtitle. */
export interface NearYouLocationContext {
  areaName?: string | null;
  state?: string | null;
}

export const DISCOVERY_COPY = {
  /** Static H1 shared by homepage hero target and market header. */
  h1: "Pre-owned items near you",
  /** Shown when no area/state location context is available (D1). */
  subtitleFallback: "Browse trusted items in Lagos & Oyo",
} as const;

/**
 * Returns "In {area} · {state}" when location context resolves, otherwise the
 * fallback subtitle. Owning this here keeps homepage and market subtitles in sync.
 */
export function formatNearYouSubtitle(
  context?: NearYouLocationContext | null,
): string {
  const area = context?.areaName?.trim();
  const state = context?.state?.trim();

  if (area && state) return `In ${area} · ${state}`;
  if (area) return `In ${area}`;
  return DISCOVERY_COPY.subtitleFallback;
}
